import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { ErrorOutline as AlertIcon } from '@mui/icons-material';
import DummyBadge from '../../common/DummyBadge';
import { toneColor, toneSoft } from './styles';
import { rowReveal } from './motion';

const ORDER = { red: 0, amber: 1, blue: 2, teal: 3 };

/** "Needs attention" rows, most urgent first; each row has one action. Renders nothing when there are no items. */
const AttentionList = ({ items = [], onAction }) => {
  const theme = useTheme();
  if (!items.length) return null;
  const sorted = [...items].sort((a, b) => (ORDER[a.tone] ?? 9) - (ORDER[b.tone] ?? 9));
  return (
    <Box>
      {sorted.map((it, i) => (
        <Box key={it.key} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.25, borderTop: i ? '1px solid' : 0, borderColor: 'divider', ...rowReveal(i) }}>
          <Box sx={{ width: 34, height: 34, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, bgcolor: toneSoft(theme, it.tone) }}>
            <AlertIcon sx={{ fontSize: 18, color: toneColor(theme, it.tone) }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography data-testid="attention-title" sx={{ fontSize: '0.8125rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75 }}>
              {it.title}{it.demo && <DummyBadge label="Demo data — waits for the dashboard backend" />}
            </Typography>
            {it.detail && <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }} noWrap>{it.detail}</Typography>}
          </Box>
          {it.action && (
            <Button size="small" variant="contained" disableElevation onClick={() => onAction?.(it)}
              color={it.tone === 'red' || it.tone === 'amber' ? 'primary' : 'inherit'}
              sx={{ textTransform: 'none', fontSize: '0.75rem', fontWeight: 700, borderRadius: '9px', whiteSpace: 'nowrap', flexShrink: 0,
                ...(it.tone === 'red' || it.tone === 'amber' ? {} : { bgcolor: toneSoft(theme, 'teal'), color: 'primary.main', boxShadow: 'none', '&:hover': { bgcolor: toneSoft(theme, 'teal') } }) }}>
              {it.action.label}
            </Button>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default AttentionList;
